// FOR ROUTER USE -- The routes cannot start w/ a slash
// This must have the same structure w/ site links -- they can differ for child modules/routing
// Base - base path for child routing
export const ROUTER_PATHS = {

    AUTH: {
        BASE: 'account',
        LOGIN: 'login/:type',
        FORGOT_PASSWORD: 'forgot-password',
        RESET_PASSWORD: 'reset-password',
        SET_PASSWORD: 'set-password',
    },

    SURVEY: 'survey/:customerIdBase64',

    PAGE_NOT_FOUND: '404',
    INVALID_INVITE: 'invalid-invite',

    DASHBOARD: `:customerId/dashboard`,

    PROFILE: {
        BASE : `:customerId/profile/:userId/user`,
        PAYMENT_METHODS: `payment-methods`,
        PASSWORD_SECURITY: `password-security`,
        COMMUNICATION_PREFERENCES: `communication-preferences`,
        AUTHORIZED_AGENTS: `authorized-agents`,
        SUBSCRIPTIONS: `subscriptions`,
    },


    SERVICE: {
        BASE: `:customerId/service`,
        DETAILS: ':serviceId',
        REQUEST: 'request'
    },

    DELIVERY: {
        BASE: `:customerId/delivery`,
        LISTS: `lists`,
        DETAILS: ':deliveryId',
        ADD: 'new',
        ADDRESS: `new/:addressId`,
        HISTORY: 'history',
        DELIVERY_STATUS_TRACKER: 'delivery-status-tracker',
    },

    INVOICE: {
        BASE: `:customerId/invoice`,
        DETAILS:':invoiceId'
    },

    OPEN_ACCOUNT: {
        BASE: 'open-account',
        SUBMITTED: 'submitted',
    },

    TANK: {
        BASE: `:customerId/tank`,
        DETAILS: ':tankId',
        DELIVERY_HISTORY: `:tankId/delivery-history`
    },

    BILLING: {
        BASE: `:customerId/billing`,
        BILLING_HISTORY: `history`,
        PAYMENT_HISTORY: `payment-history`,
        BILLING_DETAILS: `details/:invoiceId`,
        PAYMENT_DETAILS: `payment-details/:paymentId`,
        PAY_BILL: `pay-bill`,
        PAYMENT_METHOD: `payment-method`,
        STATEMENT_HISTORY: `statement-history`,
        STATEMENT_DETAILS: `statement-history/:statementId`
    }
}